var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_50_344"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_50_344)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.166658247070313,1.3542070234375L4.166658247070313,8.6458740234375C4.166338247070312,8.9333940234375,3.9333382470703127,9.1663840234375,3.6458282470703125,9.1667040234375L2.6041612470703126,9.1667040234375C2.3166472470703123,9.1663840234375,2.0836513040703126,8.9333840234375,2.0833282470703125,8.6458740234375L2.0833282470703125,1.3542070234375C2.0836511550703123,1.0666930234375,2.3166472470703123,0.8336969314375,2.6041612470703126,0.8333740234375L3.6458282470703125,0.8333740234375C3.9333382470703127,0.8336969314375,4.166338247070312,1.0666930234375,4.166658247070313,1.3542070234375ZM7.3958282470703125,0.8333740234375L6.354158247070313,0.8333740234375C6.0666482470703125,0.8336973044375,5.833648247070313,1.0666930234375,5.8333282470703125,1.3542070234375L5.8333282470703125,8.6458740234375C5.833648247070313,8.9333840234375,6.0666482470703125,9.1663840234375,6.354158247070313,9.1667040234375L7.3958282470703125,9.1667040234375C7.683348247070312,9.1663840234375,7.916338247070312,8.9333840234375,7.916658247070313,8.6458740234375L7.916658247070313,1.3542070234375C7.916338247070312,1.0666930234375,7.683348247070312,0.8336967824375,7.3958282470703125,0.8333740234375Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.7596f90837795513eb99f1d7d899712f.svg";
export { ForwardRef as ReactComponent };